import React from "react";

function Copyright() {
  return (
    <div className="flex align-center justify-center my-4">
      © 2023 Ales Mazur. All rights reserved.{" "}
    </div>
  );
}

export default Copyright;
